import React, { useState } from 'react';
import { Field, reduxForm } from 'redux-form/immutable';
import PropTypes from 'prop-types';
import NavbarModulo from '../../components/NavbarModulo';
import TablaDetalle from './DetalleManoObra';
import TablaDetalleMod from './DetalleManoObraMod';
import TablaDetalleVer from './DetalleManoObraVer';
import styled from 'styled-components';
import NumberFormat from 'react-number-format';
import classNames from 'classnames';

import {
    AsyncSelectField,
    renderField,
    renderCurrencyFloat,
    renderNumber,
    SelectField,
    renderCurrencyFloatTC,
    AsyncSelectFieldIn
} from "../../Utils/renderField/renderField";

function PresupuestoForm(props) {
    const {
        modulo,
        listarPresupuestos,
        titulo,
        crear,
        editar,
        bloqueo,
        agregarLinea,
        registroManoObra,
        detalleOrden,
        detalleOrd,
        eliminarLinea,
        agregarLineaNueva,
        modificarManoObra,
        eliminarLineaManoObra,
        buscarCliente,
        clienteProyecto,
        cambioD,
        listaTipoMO,
        listaActividad,
        listarColaboradores,
        listaColaborador
    } = props;

    const estilo = {
        overflow: "auto",
        height: "200px",

    };
    const handleOnChangeProyecto = value => {
        buscarCliente(value.value);
    };
    const [cantPersonas, setCantPersonas] = useState(0);
    const [cantHorasHombre, setCantHorasHombre] = useState(0.00);
    const [cantHorasSimple, setCantHorasSimple] = useState(0.00);
    const [cantHorasDoble, setCantHorasDoble] = useState(0.00);
    const [prestaciones, setPrestaciones] = useState(0.00);
    const [tipoEmp, setTipoEmp] = useState('');
    const [valorPrestacion, setValorPrestacion] = useState(1.4183);
    const [totalQ, setTotalQ] = useState(0.000000);
    const [montoQ, setMontoQ] = useState(0.000000);
    const [montoD, setMontoD] = useState(0.000000);
    const [salario, setSalario] = useState(0.00);
    let ruta = window.location.href;
    let id_emp = ruta.split('/');

    const tipo = [
        { label: "Colaborador", value: "CO" },
        { label: "Subcontratado", value: "SC" },
    ];

    const handleOnChangeTipo = value => {
        let salario = value.value.split('#')
        listarColaboradores(value.value);
        setSalario(parseFloat(salario[1]))
        setTotalQ(parseFloat(salario[1]))
    };

    const handleOnChangeSalario = value => {
        let salario = value.value.split('#')
        setCantPersonas(parseFloat(1))
        setSalario(parseFloat(salario[1]))
        setTotalQ(parseFloat(salario[1]))
    };

    return (
        <div>
            <NavbarModulo
                modulo={modulo}
                titulo={titulo}
            />
            <br />
            <div className="mb-4 card card-small text-white bg-dark mb-3">
                <div className="p-0 pt-3 d-flex flex-column flex-md-row">
                    <div className="d-flex flex-column flex-1 mx-4">
                        {crear === false && editar === false &&
                            <div className='row mb-2'>
                                <div className='col-10'>
                                    <Field
                                        name="nombreProyecto"
                                        placeholder="Proyecto"
                                        className="form-control"
                                        component={renderField}
                                        disabled={true}
                                        msj="Proyecto"
                                    />
                                </div>
                            </div>
                        }
                        {crear === true && editar === false &&
                            <div className='row mb-2'>
                                <div className='col-10'>
                                    <Field
                                        name="proyecto"
                                        placeholder="Proyecto..."
                                        className="form-control-find"
                                        onChange={handleOnChangeProyecto}
                                        component={AsyncSelectField}
                                        loadOptions={listarPresupuestos}
                                        msj="Proyecto"
                                    />
                                </div>
                            </div>
                        }
                        {crear === false && editar === false &&
                            <div>
                                <div className='row mb-2'>
                                    <div className='col-10'>
                                        <Field
                                            name="nombreCliente"
                                            placeholder="Cliente"
                                            className="form-control"
                                            component={renderField}
                                            disabled={true}
                                            msj="Cliente"
                                        />
                                    </div>
                                    <div className='col-2'>
                                        <Field
                                            name="tipo_cambio"
                                            placeholder="Tipo de cambio"
                                            className="form-control"
                                            component={renderCurrencyFloatTC}
                                            disabled={true}
                                            msj="Tipo de cambio"
                                        />
                                    </div>
                                </div>
                            </div>
                        }
                        {crear === true && editar === false &&
                            <div className='row mb-2'>
                                <div className='col-12'>
                                    <div className="form-floating">
                                        <input
                                            className = {classNames('form-control')}
                                            type="text"
                                            value = {clienteProyecto}
                                            disabled = {true}
                                        />
                                        <label className='form-label'>Cliente</label>
                                    </div>
                                </div>
                            </div>
                        }
                        {crear === false && editar === true &&
                            <div>
                                <div className='row mb-2'>
                                    <div className='col-10'>
                                        <Field
                                            name="nombreProyecto"
                                            placeholder="Proyecto"
                                            className="form-control"
                                            component={renderField}
                                            disabled={true}
                                            msj="Proyecto"
                                        />
                                    </div>
                                </div>
                                <div className='row mb-2'>
                                    <div className='col-10'>
                                        <Field
                                            name="proyecto_mod"
                                            placeholder="Proyecto..."
                                            className="form-control-find"
                                            onChange={handleOnChangeProyecto}
                                            component={AsyncSelectField}
                                            loadOptions={listarPresupuestos}
                                            msj="Proyecto"
                                        />
                                    </div>
                                </div>
                                <div className='row mb-2'>
                                    <div className='col-10'>
                                        <Field
                                            name="nombreCliente"
                                            placeholder="Cliente"
                                            className="form-control"
                                            component={renderField}
                                            disabled={true}
                                            msj="Cliente"
                                        />
                                    </div>
                                    <div className='col-2'>
                                        <div className="form-floating">
                                            <NumberFormat
                                                className={classNames('form-control')}
                                                decimalScale={6}
                                                disabled={true}
                                                placeholder="Tipo cambio"
                                                fixedDecimalScale
                                                thousandSeparator
                                                value={cambioD}
                                                name="totalQ"
                                            />
                                            <label className='form-label' htmlFor="total">
                                            Tipo cambio
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        }
                        {crear === true && editar === false &&
                            <div className='row mb-2'>
                                <div className='col-2'>
                                    <div className="form-floating">
                                        <NumberFormat
                                            className={classNames('form-control')}
                                            decimalScale={6}
                                            fixedDecimalScale
                                            placeholder="Tipo de cambio"
                                            value={cambioD}
                                            disabled={true}
                                            thousandSeparator
                                        />
                                        <label className='form-label' htmlFor="cuenta">
                                            Tipo de cambio
                                        </label>
                                    </div>
                                </div>
                                {/*<div className='col-3 mt-2'>
                                    <button
                                        className='btn mr-2 mb-3 btn-secondary'
                                        onClick={() => {
                                            let tc = tipoCambio(fechaInicio, fechaFinal);
                                            tc.then(d => { 
                                                setTipoCambioD(d);
                                            });
                                            
                                        }}
                                    >
                                        Buscar tipo de cambio
                                    </button>
                                </div>**/}
                                <div className='col-2'>
                                </div>
                            </div>
                        }
                        <div className='mb-2'>
                            <Field
                                name="observaciones"
                                placeholder="Observaciones"
                                component={renderField}
                                className="form-control"
                                disabled={bloqueo}
                                msj="Observaciones"
                            />
                        </div>
                        <h5 className="p-2 bg-secondary title mt-1">Detalle mano de obra</h5>
                        {(crear === true || editar === true) &&
                            <div>
                                <div className='row mb-2'>
                                    <div className='col-3'>
                                        <Field
                                            name="tipo_mdo"
                                            placeholder="Tipo mano de obra..."
                                            className="form-control-find"
                                            loadOptions={listaTipoMO}
                                            onChange={handleOnChangeTipo}
                                            component={AsyncSelectFieldIn}
                                            msj="Tipo MDO"
                                        />
                                    </div>
                                    <div className='col-6'>
                                        <Field
                                            name="colaborador"
                                            placeholder="Colaborador..."
                                            className="form-control-find"
                                            loadOptions={listaColaborador}
                                            onChange={handleOnChangeSalario}
                                            component={AsyncSelectFieldIn}
                                            msj="Colaborador"
                                        />
                                    </div>
                                    <div className='col-3'>
                                        <Field
                                            name="actividad"
                                            placeholder="Actividad..."
                                            className="form-control-find"
                                            loadOptions={listaActividad}
                                            component={AsyncSelectFieldIn}
                                            msj="Actividad"
                                        />
                                    </div>
                                </div>
                                <div className='row mb-2'>
                                    <div className='col-2'>
                                        <Field
                                            name="tipo"
                                            options={tipo}
                                            crear={crear}
                                            dato={0}
                                            component={SelectField}
                                            className="form-select"
                                            msj="Tipo"
                                            onChange={(e, value) => {
                                                setTipoEmp(value)
                                            }}
                                        />
                                    </div>
                                    <div className='col-2'>
                                        <Field
                                            name="horas_hombre_ordinarias"
                                            placeholder="Horas ordinarias"
                                            className="form-control"
                                            component={renderCurrencyFloat}
                                            msj="Horas ordinarias"
                                            onChange={(e, value) => {
                                                if (value) {
                                                    setCantHorasHombre(value);
                                                    if (totalQ !== 0){
                                                        let total = parseFloat(((parseFloat(totalQ) / 30) / 8) * parseFloat(value)).toFixed(2);
                                                        let totalHorasSimple = parseFloat(((parseFloat(totalQ) / 30) / 8 * 1.5) * parseFloat(cantHorasSimple)).toFixed(2);
                                                        let totalHorasDoble = parseFloat(((parseFloat(totalQ) / 30) / 8 * 2) * parseFloat(cantHorasDoble)).toFixed(2);
                                                        let granTotal = parseFloat(parseFloat(total) + parseFloat(totalHorasSimple) + parseFloat(totalHorasDoble)).toFixed(2);
                                                        let totalM = parseFloat(parseFloat(granTotal) * parseFloat(cantPersonas)).toFixed(2);
                                                        let totalD = parseFloat(parseFloat(totalM) / parseFloat(cambioD)).toFixed(2);
                                                        setMontoQ(totalM);
                                                        setMontoD(totalD);
                                                        if (tipoEmp === 'CO') {
                                                            let prestacion = parseFloat(parseFloat(totalM) * parseFloat(valorPrestacion)).toFixed(2);
                                                            setPrestaciones(prestacion);
                                                        }
                                                    }
                                                }
                                            }}
                                        />
                                    </div>
                                    <div className='col-2'>
                                        <Field
                                            name="horas_hombre_simples"
                                            placeholder="Horas extras simples"
                                            className="form-control"
                                            component={renderCurrencyFloat}
                                            msj="Horas extras simples"
                                            onChange={(e, value) => {
                                                if (value) {
                                                    setCantHorasSimple(value);
                                                    if (totalQ !== 0){
                                                        let total = parseFloat(((parseFloat(totalQ) / 30) / 8) * parseFloat(cantHorasHombre)).toFixed(2);
                                                        let totalHorasSimple = parseFloat(((parseFloat(totalQ) / 30) / 8 * 1.5) * parseFloat(value)).toFixed(2);
                                                        let totalHorasDoble = parseFloat(((parseFloat(totalQ) / 30) / 8 * 2) * parseFloat(cantHorasDoble)).toFixed(2);
                                                        let granTotal = parseFloat(parseFloat(total) + parseFloat(totalHorasSimple) + parseFloat(totalHorasDoble)).toFixed(2);
                                                        let totalM = parseFloat(parseFloat(granTotal) * parseFloat(cantPersonas)).toFixed(2);
                                                        let totalD = parseFloat(parseFloat(totalM) / parseFloat(cambioD)).toFixed(2);
                                                        setMontoQ(totalM);
                                                        setMontoD(totalD);
                                                        if (tipoEmp === 'CO') {
                                                            let prestacion = parseFloat(parseFloat(totalM) * parseFloat(valorPrestacion)).toFixed(2);
                                                            setPrestaciones(prestacion);
                                                        }
                                                    }
                                                }
                                            }}
                                        />
                                    </div>
                                    <div className='col-2'>
                                        <Field
                                            name="horas_hombre_dobles"
                                            placeholder="Horas extras dobles"
                                            className="form-control"
                                            component={renderCurrencyFloat}
                                            msj="Horas extras dobles"
                                            onChange={(e, value) => {
                                                if (value) {
                                                    setCantHorasDoble(value);
                                                    if (totalQ !== 0){
                                                        let total = parseFloat(((parseFloat(totalQ) / 30) / 8) * parseFloat(cantHorasHombre)).toFixed(2);
                                                        let totalHorasSimple = parseFloat(((parseFloat(totalQ) / 30) / 8 * 1.5) * parseFloat(cantHorasSimple)).toFixed(2);
                                                        let totalHorasDoble = parseFloat(((parseFloat(totalQ) / 30) / 8 * 2) * parseFloat(value)).toFixed(2);
                                                        let granTotal = parseFloat(parseFloat(total) + parseFloat(totalHorasSimple) + parseFloat(totalHorasDoble)).toFixed(2);
                                                        let totalM = parseFloat(parseFloat(granTotal) * parseFloat(cantPersonas)).toFixed(2);
                                                        let totalD = parseFloat(parseFloat(totalM) / parseFloat(cambioD)).toFixed(2);
                                                        setMontoQ(totalM);
                                                        setMontoD(totalD);
                                                        if (tipoEmp === 'CO') {
                                                            let prestacion = parseFloat(parseFloat(totalM) * parseFloat(valorPrestacion)).toFixed(2);
                                                            setPrestaciones(prestacion);
                                                        }
                                                    }
                                                }
                                            }}
                                        />
                                    </div>
                                </div>
                                <div className='row mb-2'>
                                    {/*<div className='col-2'>
                                        <Field
                                            name="monto_q"
                                            placeholder="Monto quetzales"
                                            className="form-control"
                                            component={renderCurrencyFloat}
                                            msj="Monto mensual"
                                            onChange={(e, value) => {
                                                if (cantHorasHombre === 0 || cantHorasHombre === 0.000000) {
                                                    Swal.fire({
                                                        title: 'Mano de obra',
                                                        text: 'Debe de ingresar horas hombre',
                                                        type: 'error',
                                                    })
                                                }else{
                                                    if (cantPersonas === 0) {
                                                        Swal.fire({
                                                            title: 'Mano de obra',
                                                            text: 'Debe de ingresar cantidad de personas',
                                                            type: 'error',
                                                        })
                                                    }else{
                                                        if (cambioD === 0 || cambioD === 0.000000) {
                                                            Swal.fire({
                                                                title: 'Mano de obra',
                                                                text: 'Debe seleccionar un proyecto para obtener el tipo de cambio',
                                                                type: 'error',
                                                            })
                                                        }else{
                                                            if (value) {
                                                                let total = parseFloat(((parseFloat(value) / 30) / 8) * parseFloat(cantHorasHombre)).toFixed(2);
                                                                let totalHorasSimple = parseFloat(((parseFloat(value) / 30) / 8 * 1.5) * parseFloat(cantHorasSimple)).toFixed(2);
                                                                let totalHorasDoble = parseFloat(((parseFloat(value) / 30) / 8 * 2) * parseFloat(cantHorasDoble)).toFixed(2);
                                                                let granTotal = parseFloat(parseFloat(total) + parseFloat(totalHorasSimple) + parseFloat(totalHorasDoble)).toFixed(2);
                                                                let totalM = parseFloat(parseFloat(granTotal) * parseFloat(cantPersonas)).toFixed(2);
                                                                let totalD = parseFloat(parseFloat(totalM) / parseFloat(cambioD)).toFixed(2);
                                                                setTotalQ(value);
                                                                setMontoQ(totalM);
                                                                setMontoD(totalD);
                                                                if (tipoEmp === 'CO') {
                                                                    let prestacion = parseFloat(parseFloat(totalM) * parseFloat(valorPrestacion)).toFixed(2);
                                                                    setPrestaciones(prestacion);
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }}
                                        />
                                    </div>*/}
                                    <div className='col-2'>
                                        <div className="form-floating">
                                            <NumberFormat
                                                className={classNames('form-control')}
                                                decimalScale={2}
                                                disabled={true}
                                                placeholder="Salario mensual"
                                                fixedDecimalScale
                                                thousandSeparator
                                                value={salario}
                                                name="salario"
                                            />
                                            <label className='form-label' htmlFor="total">
                                            Salario mensual
                                            </label>
                                        </div>
                                    </div>
                                    <div className='col-2'>
                                        <div className="form-floating">
                                            <NumberFormat
                                                className={classNames('form-control')}
                                                decimalScale={2}
                                                disabled={true}
                                                placeholder="Monto quetzales"
                                                fixedDecimalScale
                                                thousandSeparator
                                                value={montoQ}
                                                name="totalQ"
                                            />
                                            <label className='form-label' htmlFor="total">
                                            Monto quetzales
                                            </label>
                                        </div>
                                    </div>
                                    <div className='col-2'>
                                        <div className="form-floating">
                                            <NumberFormat
                                                className={classNames('form-control')}
                                                decimalScale={2}
                                                disabled={true}
                                                placeholder="Monto dólares"
                                                fixedDecimalScale
                                                thousandSeparator
                                                value={montoD}
                                                name="totalQ"
                                            />
                                            <label className='form-label' htmlFor="total">
                                            Monto dólares
                                            </label>
                                        </div>
                                    </div>
                                    <div className='col-2'>
                                        <div className="form-floating">
                                            <NumberFormat
                                                className={classNames('form-control')}
                                                decimalScale={2}
                                                disabled={true}
                                                placeholder="Prestaciones laborales"
                                                fixedDecimalScale
                                                thousandSeparator
                                                value={prestaciones}
                                                name="totalQ"
                                            />
                                            <label className='form-label' htmlFor="total">
                                            Prestaciones laborales
                                            </label>
                                        </div>
                                    </div>
                                </div>
                                
                            </div>
                        }
                        {(crear === true) &&
                            <Contenido>
                                <button
                                    className='btn mr-2 mb-3 btn-primary'
                                    onClick={() => {
                                        setMontoD(0.00);
                                        setMontoQ(0.00);
                                        setTotalQ(0.00);
                                        setCantPersonas(0);
                                        setCantHorasHombre(0.00);
                                        setCantHorasSimple(0.00);
                                        setCantHorasDoble(0.00);
                                        setPrestaciones(0.00);
                                        agregarLinea(cambioD, cantPersonas, cantHorasHombre, totalQ, cantHorasSimple, cantHorasDoble, tipoEmp, valorPrestacion);
                                        setSalario(0.00);
                                    }}
                                >
                                    Agregar
                                </button>
                            </Contenido>
                        }
                        {(editar === true) &&
                            <Contenido>
                                <button
                                    className='btn mr-2 mb-3 btn-primary'
                                    onClick={() => {
                                        setMontoD(0.00);
                                        setMontoQ(0.00);
                                        setTotalQ(0.00);
                                        setCantPersonas(0);
                                        setCantHorasHombre(0.00);
                                        setCantHorasSimple(0.00);
                                        setCantHorasDoble(0.00);
                                        setPrestaciones(0.00);
                                        agregarLineaNueva(cambioD, cantPersonas, cantHorasHombre, totalQ, cantHorasSimple, cantHorasDoble, tipoEmp, valorPrestacion);
                                        setSalario(0.00);
                                    }}
                                >
                                    Agregar
                                </button>
                            </Contenido>
                        }
                        {crear === true && editar === false &&
                            <div style={estilo}>
                                <TablaDetalle
                                    detalle={detalleOrden}
                                    eliminarLinea={eliminarLinea}
                                />
                            </div>
                        }
                        {crear === false && editar === true &&
                            <div style={estilo}>
                                <TablaDetalleMod
                                    detalle={detalleOrd}
                                    eliminarLineaGasto={eliminarLineaManoObra}
                                />
                            </div>
                        }
                        {crear === false && editar === false &&
                            <div style={estilo}>
                                <TablaDetalleVer
                                    detalle={detalleOrd}
                                />
                            </div>
                        }
                        <br />
                        <div className='d-flex flex-row mt-3'>
                            {crear === true && editar === false &&
                                <button
                                    className='btn mr-2 mb-3 btn-primary'
                                    onClick={() => registroManoObra(detalleOrden, cambioD)}
                                >
                                    Guardar
                                </button>
                            }
                            {editar === true && crear === false &&
                                <button
                                    className='btn mr-2 mb-3 btn-primary'
                                    onClick={() => modificarManoObra(detalleOrden)}
                                >
                                    Modificar
                                </button>
                            }
                            <a
                                href={`/#/gestion_proyecto/${id_emp[5]}/mano_obra`}
                                className='btn btn-secondary mb-3'
                            >
                                Regresar
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

PresupuestoForm.propTypes = {
    crear: PropTypes.bool,
};

export default reduxForm({
    form: 'FormManoObra',
})(PresupuestoForm);

const Contenido = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;

`;